import { createUseStyles } from 'react-jss';

export const useHomeOurProducts = createUseStyles({
  'lens-transition': {
    opacity: 0,
    transition: 'opacity 250ms ease-in-out',
    '&.lens-transition-enter-active, &.lens-transition-enter-done': {
      opacity: 1,
    },
    '&.lens-transition-leave-active': {
      opacity: 0,
    },
  },

  ourProductSlides: {
    display: 'flex !important',
    flex: '1',
  },

  slickDots: {
    position: 'absolute',
    bottom: '0px',
    top: '-60px',
    right: '0px',
    display: 'flex !important',
    width: '100%',
    padding: '0',
    margin: '0 0 20px 0',
    listStyle: 'none',
    textAlign: 'center',
    justifyContent: 'flex-end',
    zIndex: '-1',

    '@media (min-width: 1024px)': {
      top: '-80px',
    },

    '& li': {
      position: 'relative',
      display: 'inline-block',
      width: '18px',
      height: '10px',
      margin: '0 8px',
      padding: '0',
      cursor: 'pointer',

      '@media (min-width: 1024px)': {
        width: '32px',
        height: '18px',
      },

      '&.slick-active': {
        background: 'white',
        borderColor: 'white',
        transform: 'scale(1)',
        opacity: '1',
      },

      '& button': {
        fontSize: 0,
        lineHeight: 0,
        display: 'block',
        width: '18px',
        height: '5px',
        padding: '0px',
        cursor: 'pointer',
        color: 'transparent',
        border: '1px solid white',
        outline: 'none',
        background: 'white',
        opacity: '0.3',
        transition: 'transform .2s ease-in-out',
        transform: 'none',

        '@media (min-width: 1024px)': {
          width: '32px',
          height: '6px',
          padding: '5px',
        },

        '&:hover , &:focus': {
          outline: 'none',
          '&:before': {
            opacity: 1,
          },
        },
        '&:before': {
          fontSize: '6px',
          lineHeight: '20px',
          position: 'absolute',
          top: '0',
          left: '0',
          width: '20px',
          height: '15px',
          content: '•',
          textAlign: 'center',
          opacity: '.25',
          color: 'black',
          '-webkitFontSmoothing': 'antialiased',
          '-mozOsxFontSmoothing': 'grayscale',
        },
      },
    },
  },
});
